(ns common.i18n.icu
  #?(:cljs (:require ["@messageformat/core" :as message-format]
                     [applied-science.js-interop :as j])))

(defn msg
  "Takes an icu message template and returns a function to translate given a map of named parameters.
  Parameters to the returned function are run through `clj->js`. Kebab-case does NOT work. Use camelCase for symbols within the icu message str.

Usage:
  Single plural - ((msg \"I have {count, plural, =0 {no candies} =1 {one candy} other {# candies}}\") {:count 3})
  Multiple types - ((msg
                   \"{gender, select, male {He} female {She} other {They}} found {resultsCount, plural, =0 {no results} one {1 result} other {# results}}.\")
                   {:gender \"male\"
                    :resultsCount 1})"
  [x]
  #?(:clj x
     :cljs (with-meta
             (let [msg-fn (-> (message-format.) (j/call :compile x))]
               ;; clj-js is so it can be supplied with clj maps like {:count 3}
               ;; using camel-snake-kebab isn't possible since the message format only supports camel
               #(msg-fn (clj->js %)))
             {:i18n/dictionary-symbol     'icu/msg
              :i18n/string-representation x})))
